// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { ImageProviderListResponse } from '@par/app/core/model/dictionaries.response';

export const getImageProviderListRequested = createAction('[SELECT IMAGE PROVIDER] Get Image Provider List Requested');
export const getImageProviderListSucceeded = createAction('[SELECT IMAGE PROVIDER] Get Image Provider List Succeeded', props<{
  response: ImageProviderListResponse
}>());
export const getImageProviderListFailed = createAction('[SELECT IMAGE PROVIDER] Get Image Provider List Failed');
